export default __webpack_public_path__ + "static/media/background.48d26568.svg";